module.exports = __webpack_public_path__ + "static/media/sign_language.509488ae.png";